<ion-content>
  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="stopwatch-outline"></ion-icon>Custom SLAs</h1>
          <p class="subtitle">
            Create pre-configured SLAs that can be applied to multiple customers based on different response time goals.
            You can apply these SLAs to any customer or channel.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card
            class="outline-card"
            *ngFor="let supportStepRuleset of supportStepRulesets; let i = index"
            style="margin: 10px 10px 30px 10px"
          >
            <div *ngIf="showingIndex !== i">
              <h3 style="margin: 20px 20px 5px 20px">
                {{ supportStepRuleset.name }}
              </h3>
              <div class="flex-space-between">
                <ion-button fill="clear" (click)="toggleShowing(i)">
                  <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
                  Edit configuration
                </ion-button>
              </div>
            </div>
            <div *ngIf="showingIndex === i">
              <ion-card-header>
                <ion-input
                  [(ngModel)]="supportStepRuleset.name"
                  class="input-field big-title-input"
                  placeholder="Name your SLA (ex: 'Premium Support')"
                  autocapitalize="sentences"
                  (click)="showingIndex = i"
                >
                </ion-input>
              </ion-card-header>

              <ion-card-content>
                <div class="subtitle">Description</div>
                <ion-textarea
                  placeholder="Ex: Rules for customers with the premium plan."
                  [(ngModel)]="supportStepRuleset.description"
                  class="input-field"
                  style="margin: 0"
                ></ion-textarea>
              </ion-card-content>

              <app-support-steps
                [initialSupportSteps]="supportStepRuleset.rules"
                (didChange)="supportStepsDidChange($event, i)"
                [isDefaults]="true"
              >
              </app-support-steps>

              <div class="border-top">
                <ion-button color="success" (click)="save(i)" class="save-button"> Save changes </ion-button>
                <ion-button fill="clear" (click)="toggleShowing(i)" *ngIf="hasSupportStepRulesets"> Cancel </ion-button>
                <ion-button color="danger" fill="clear" (click)="delete(i)" *ngIf="hasSupportStepRulesets">
                  Delete
                </ion-button>
              </div>
            </div>
          </ion-card>
          <ion-button
            fill="clear"
            size="block"
            class="btn-large"
            style="margin: 32px 12px"
            (click)="addSupportStepRuleset()"
            *ngIf="hasSupportStepRulesets && supportStepRulesets[supportStepRulesets.length - 1].id"
          >
            <ion-icon name="add-outline" class="padded-icon"></ion-icon>Add another ruleset
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
